/**
 * Blurb actions wrapper for buttons and CTAs.
 */
export default function BlurbActions({ children, className = '' }) {
  if (!children) return null;

  return <div className={`Blurb__actions ${className}`}>{children}</div>;
}
